<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { frontendUrl } from '@/config';
import languageToSlug from '@/helpers/languageToSlug';
import mustBeLink from '@/helpers/vuelidate/mustBeLink';
import SingleView from '@/components/elements/views/SingleView';
import AddEditForm from '@/components/clinical-researches/categories/AddEditSubcategoryForm';

export default {
    page: {
        title: 'Manage Clinical Research Subcategory'
    },

    components: {
        AddEditForm
    },

    extends: SingleView,

    validations: {
        item: {
            title: {
                required
            },
            link: {
                required,
                mustBeLink
            }
        }
    },

    data() {
        const { categoryId } = this.$route.params;

        return {
            categoryId,
            backRoute: `/clinical-research-categories/${categoryId}/edit`,
            indexName: 'Clinical Research Subcategory',
            singleItemName: 'clinical research subcategory',
            languagePicker: false,
            excludeSlug: true,
            meta: false,
            item: {
                title: '',
                link: '',
                categoryId
            }
        };
    },

    computed: {
        sections() {
            const sections = {
                permalink: false
            };

            if (this.editMode) {
                sections.status = true;
            }

            return sections;
        },

        breadcrumbs() {
            return [
                {
                    text: 'Cancer',
                    to: '/'
                },
                {
                    text: 'Clinical Research Categories',
                    to: `/clinical-research-categories`
                },
                {
                    text: 'Category',
                    to: this.backRoute
                },
                {
                    text: 'Subcategory',
                    active: true
                },
                {
                    text: this.id ? 'Edit' : 'Add',
                    active: true
                }
            ];
        },

        previewUrl() {
            const {
                category: { slug, language }
            } = this.item;

            const languageSlug = languageToSlug(language);

            const url = frontendUrl.concat(languageSlug);

            return url.concat(`/clinical-researches/categories/${slug}`);
        }
    },

    methods: {
        ...mapActions({
            addItem: 'clinicalResearchSubcategories/store',
            deleteItem: 'clinicalResearchSubcategories/destroy',
            getItem: 'clinicalResearchSubcategories/show',
            updateItem: 'clinicalResearchSubcategories/update'
        }),

        constructStoreActionBackRoute(data) {
            return `/clinical-research-categories/${this.categoryId}/subcategories/${data.id}/edit`;
        }
    }
};
</script>
